export default __webpack_public_path__ + "static/media/bell.d77e8e43.svg";